module.exports = __webpack_public_path__ + "img/bf75f2924a0123817b8cb90c61732dd3.png";